<h1 mat-dialog-title> Valida Postulación </h1> <br/>

<mat-dialog-content>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Beneficiario </mat-label>

            <mat-select *ngIf = "data.carga" [(ngModel)] = "data.beneficiario" [disabled] = "data.deshabilitado" required>

                <mat-option *ngFor = "let postulante of data.postulantes" value = "{{postulante.id}}">

                    {{postulante.rut}} - {{postulante.dv}} {{postulante.nombres}} {{postulante.apellidoPaterno}}

                </mat-option>

            </mat-select>

            <input *ngIf = "!data.carga" matInput [disabled] = "true" [value] = "data.beneficiario" />

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Tipo de Producto </mat-label>

            <mat-select [(ngModel)] = "data.tipoProducto" [disabled] = "true" required>

                <mat-option *ngFor = "let tipo of data.tiposBeca" value = "{{tipo.id}}">

                    {{tipo.descripcion}}

                </mat-option>

            </mat-select>

        </mat-form-field>
    </p>

    <p>
        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Etapa Escolar </mat-label>

            <mat-select [(ngModel)] = "data.etapaEscolar" [disabled] = "data.deshabilitado" required>

                <mat-option *ngFor = "let curso of data.cursos" value = "{{curso.id}}">

                    {{curso.descripcion}}

                </mat-option>

            </mat-select>

        </mat-form-field>
    </p>

    <p *ngIf = "!data.muestraDiagnostico">

        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Calificación </mat-label>

            <input matInput placeholder = "Calificación" [(ngModel)] = "data.calificacion"
            pattern = "[1-7]{1}[.]{1}[0-9]{3}" [disabled] = "data.deshabilitado">

        </mat-form-field>

    </p>
    <p *ngIf = "data.muestraDiagnostico">

        <mat-form-field appearance = "outline" class = "mat-input">

            <mat-label> Diagnóstico </mat-label>
            <input matInput placeholder = "Diagnóstico" [(ngModel)] = "data.diagnostico"
            [disabled] = "data.deshabilitado">

        </mat-form-field>

    </p>

    <p>
        <button class = "mat-raised-button btn-info" (click) = "onDescargarArchivosClick(data.idPostulacion)">

        <i class = "fa fa-download"> </i> Descargar Archivo Ingresado</button>
    </p>

</mat-dialog-content> <br/>

<mat-dialog-actions>
    <div *ngIf = "data.rol !=( 'ROLE_EJECUTIVO_CAIP' &&'ROLE_ENCARGADO_NACIONAL') ;  else roleReadOnly"> 
        <button *ngIf = "!data.presionaEditar && data.mostrarEditar" mat-button class = "mat-raised-button btn-warning" (click) = "onEditarClick()">
            <i class ="fa fa-pen"> </i> Editar
        </button>

        <button *ngIf = "!data.presionaEditar && data.mostrarEditar" mat-button class = "mat-raised-button btn-success" (click) = "onAprobarClick()">
            <i class = "fa fa-check"> </i> Aprobar
        </button>
    
    
            <button *ngIf = "!data.presionaEditar && data.mostrarEditar" mat-button class = "mat-raised-button btn-danger" (click) = "onRechazarClick()">
                <i class = "fa fa-times"> </i> Rechazar
            </button>
    
        <button *ngIf = "data.presionaEditar && data.mostrarEditar" mat-button class = "mat-raised-button btn-success"
        (click) = "onGuardarClick(data.carga ? data.beneficiario : null,!data.carga ? data.idUsuario : null)">
            <i class = "fa fa-download"> </i> Guardar
        </button>
        <button mat-button class = "mat-raised-button btn-dark" (click) = "onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>
    <ng-template #roleReadOnly>
        <button mat-button class = "mat-raised-button btn-dark" (click) = "onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </ng-template> 
   

</mat-dialog-actions>
